/* @flow */

import * as React from 'react';
import { compose, withProps } from 'recompose';
import moment from 'moment';
import 'moment-duration-format';
import t from 'app/utils/translate';
import withTimer from 'app/hoc/withTimer';
import CountdownClock from './CountdownClock';

type Props = {
  format?: string,
  subscribe: () => void,
  remaining: number,
  unsubscribe: () => void,
  onTimeOut?: () => void,
  label?: string,
  status?: 'warning' | 'normal' | 'danger' | 'default'
};

class Countdown extends React.Component<Props> {
  props: Props;

  static defaultProps = {
    format: undefined,
    label: 'Starts in ',
    onTimeOut: undefined,
    status: undefined
  };

  componentDidMount() {
    const { remaining, subscribe } = this.props;

    if (remaining > 0) {
      subscribe();
    }
  }

  componentDidUpdate() {
    const { remaining, unsubscribe } = this.props;

    if (remaining === 0) {
      unsubscribe();
    }
  }

  componentWillUnmount() {
    const { unsubscribe } = this.props;
    unsubscribe();
  }

  render() {
    const { format, label, remaining, onTimeOut, status } = this.props;

    if (remaining === 0) {
      if (typeof onTimeOut === 'function') {
        onTimeOut();
        return null;
      }
      return <CountdownClock status="danger">{t('Lockout')}</CountdownClock>;
    }

    if (remaining <= 60) {
      return (
        <CountdownClock status={status || 'warning'}>
          {t(`${label}*remaining* seconds`).replace('*remaining*', remaining)}
        </CountdownClock>
      );
    }

    const duration = moment.duration(remaining, 'seconds');
    const timeFormat = format || (duration.days() > 0 ? 'dd:hh:mm:ss' : 'hh:mm:ss');
    const secondsRemaining = duration.format(timeFormat, { trim: false });

    return (
      <CountdownClock status={status || 'normal'}>
        {t(`${label}*seconds*`).replace('*seconds*', secondsRemaining)}
      </CountdownClock>
    );
  }
}

const enhance = compose(
  withTimer,
  withProps(props => ({
    remaining: Math.max(0, moment(props.starting).diff(moment(props.timestamp), 'seconds'))
  }))
);

export default enhance(Countdown);
